//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LinsesDescription',
  props: {
    linza: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    descriptions() {
      return this?.linza?.description || '';
    },
    designChars() {
      return this?.linza?.design_chars || [];
    },

    imageId() {
      return this?.linza?.additional_image_id || 0;
    },

    isShowDescription() {
      return Boolean(this.designChars?.[0]?.length)
    }

  },
}
